module.exports = __webpack_public_path__ + "static/media/49_A.fc433f7f.png";